KROWN.themeName = 'Split';
KROWN.themeVersion = '4.4.0';

const executeOnceOnDomContentLoaded = ()=>{

  // tab navigation

  let activeElement = document.activeElement;
  document.addEventListener('keyup', e=>{
    if ( e.keyCode == window.KEYCODES.TAB ) {
      if ( activeElement.classList.contains('focus') && e.target != activeElement ) {
        activeElement.classList.remove('focus');
      }
      if ( e.target.classList.contains('product-variant__input') ||
      	e.target.classList.contains('button') ||
      	e.target.classList.contains('product-item') ||
      	e.target.classList.contains('site-box-content-to-focus')
      ) {
        e.target.classList.add('focus');
      } 
      activeElement = document.activeElement;
    }
  });

  // newsletter has jump

  if ( window.location.pathname.includes('/challenge') ) {
    setTimeout(()=>{
      window.scroll({
        top: 0, 
        behavior: 'auto'
      });
    }, 300);
  }

  // fix image link borders

  document.querySelectorAll('.rte a img').forEach(elm=>{
    elm.parentNode.style.border = 'none';
  });

  // Filter handle
  
  if ( document.getElementById('site-filter-handle') ) {
    document.getElementById('site-filter-handle').addEventListener('click', e=>{
      e.preventDefault();
      document.getElementById('site-filters').show();
      document.getElementById('site-filter-handle').setAttribute('aria-expanded', 'true');
    });
  }

  // fix quick add to cart

  setTimeout(()=>{
    if ( document.querySelector('modal-box quick-view-product') ) {
      document.querySelector('modal-box quick-view-product').init();
    }
    if ( document.querySelector('modal-box quick-add-to-cart') ) {
      document.querySelector('modal-box quick-add-to-cart').init();
      document.querySelector('modal-box product-form').init();
    }
  }, 3050);

  // show newsletter popup confimation

  if ( document.location.search == '?customer_posted=true' && document.location.hash == '#newsletter-popup' && document.getElementById('modal-newsletter') ) {
    const newsletterPopup = document.getElementById('modal-newsletter');
    newsletterPopup.show();
    localStorage.setItem(newsletterPopup._modalKey, JSON.stringify({
      'shown': (new Date().getTime()),
      'content': newsletterPopup._modalText
    }));	
    setTimeout(()=>{
      newsletterPopup.querySelectorAll('[data-js-close]').forEach(elm=>elm.addEventListener('click',()=>{newsletterPopup.hide(true)}));
    }, 100);
    clearTimeout(newsletterPopup._modalTimeout);
  }

  // custom cart listener
  
  if ( document.querySelector('cart-form') ) {
    document.querySelector('cart-form').addEventListener('cart-updated', ()=>{
      if ( document.body.classList.contains('template-cart') ) {

        if ( document.querySelector('#AjaxCartForm .subtitle') ) {
          document.querySelector('#section-cart .box__heading .subtitle').innerHTML = document.querySelector('#AjaxCartForm .subtitle').innerHTML;
        }
        if ( document.getElementById('AjaxCartSubtotal').querySelector('[data-cart-empty]') ) {
          document.querySelector('#section-cart .box__heading .subtitle').innerHTML = "";
          if ( ! document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content') ) {
            document.getElementById('AjaxCartSubtotal').append(document.getElementById('section-cart').querySelector('template').content.cloneNode(true))
          } else {
            document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content').style.display = 'block';
          }
        } else if ( document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content') ) {
          document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content').style.display = 'none';
        }

      }

      if ( document.querySelector('cart-recommendations') && parseInt(document.querySelector('[data-cart-count]').textContent ) == 0 ) {
        document.querySelector('cart-recommendations').innerHTML = '';
      }

    });
  }

  // recommended products listener

  if ( document.querySelector('#main-product-recommendations') ) {
    document.querySelector('#main-product-recommendations').addEventListener('product-recommendations-loaded', ()=>{

      const cssStyle = document.querySelector('[id^="css-fix-height-"]');
      if (!cssStyle) {
        console.warn('Could not find css-fix-height element');
        return;
      }
      
      const sectionId = cssStyle.id.replace('css-fix-height-', '');
      const heightElement = document.getElementById(`fix-height-with-${sectionId}`);
      
      if (cssStyle && heightElement) {
        const fixCollectionHeight = () => {
          const height = heightElement.offsetHeight - 1;
          cssStyle.innerHTML = `@media screen and (min-width: 1025px), screen and (min-width: 769px) and (orientation: landscape) { 
            #fix-height-${sectionId} {
              height: ${height}px !important;
            }
          }`;
        };
        
        setTimeout(fixCollectionHeight, 100);
        window.addEventListener('resize', fixCollectionHeight);
      } else {
        console.warn('Missing required elements for height fixing');
      }
    });
  }

}

if ( document.readyState !== 'loading' ) {
  executeOnceOnDomContentLoaded();
} else {
  document.addEventListener('DOMContentLoaded', executeOnceOnDomContentLoaded);
}

if ( typeof SiteFilterHandle !== 'function' ) {

	class SiteFilterHandle extends HTMLElement {
		constructor(){
			super();
			const sidebar = document.getElementById(this.getAttribute('aria-controls'));
			this.addEventListener('click', e=>{
				if ( ! this.classList.contains('disable-sidebar') ) {
					e.preventDefault();
					this.setAttribute('aria-expanded', 'true');
					sidebar.show();
				}
			})
			this.addEventListener('keyup', e=>{
				if ( e.keyCode == window.KEYCODES.RETURN ) {
					this.setAttribute('aria-expanded', 'true');
					sidebar.show();
					sidebar.querySelector('.site-close-handle').focus();
				}
			})
		}
  }

  if ( typeof customElements.get('site-filter-handle') == 'undefined' ) {
    customElements.define('site-filter-handle', SiteFilterHandle);
  }

}







// ================= Maison Brutal – highlight + subtle glitch =================
// This single script handles BOTH features in the right order so they don’t
// step on each other.  
// 1️⃣ brutalHighlightAll() – wraps everything between [[ … ]] inside
//    <span class="brutal-highlight"> … </span>. It runs **first**.
// 2️⃣ glitchElements() – launches a very‑subtle, continuous letter scramble on
//    all <p>, .tagline and .subtitle nodes, AFTER highlighting is done so the
//    mutation does not cancel the running intervals.
// -----------------------------------------------------------------------------

/* ---------------------------------------------------------------------------
   BRUTAL HIGHLIGHT  (runs once)
   -------------------------------------------------------------------------*/
function brutalHighlightAll() {
  document.querySelectorAll('.site-box-content').forEach(root => {
    // Preserve <br> tags while working on a pure string
    const BR = '___BR___';
    let html = root.innerHTML.replace(/<br\s*\/?>/gi, BR);

    // Replace every [[ … ]] (even across line breaks)
    html = html.replace(/\[\[((?:.|\n|\r)+?)\]\]/g, (_m, inside) =>
      `<span class="brutal-highlight">${inside}</span>`
    );

    root.innerHTML = html.replace(new RegExp(BR, 'g'), '<br>');
  });
}

/* ---------------------------------------------------------------------------
   SUBTLE GLITCH (continuous)
   -------------------------------------------------------------------------*/

// – Tweaks you may want to play with –
const FRAME_COUNT      = 120;   // higher = slower cascade per session
const LETTER_CHANCE    = 0.08;  // fraction of letters affected in each session
const LOOP_INTERVAL_MS = 15000; // average delay between two sessions on 1 node

function subtleScrambleTextNode(node, duration = 20000) {
  const base  = node.textContent;
  if (!base.trim()) return;             // skip empty nodes
  const chars = '1234567890';
  const arr   = base.split('');

  function newSession() {
    return {
      frame       : 0,
      delays      : arr.map(() => Math.floor(Math.random() * FRAME_COUNT)),
      glitchDur   : arr.map(() => (Math.random() < LETTER_CHANCE ? 2 + Math.floor(Math.random()*2) : 0))
    };
  }

  let session = newSession();
  clearInterval(node._glInt);

  node._glInt = setInterval(() => {
    const { frame, delays, glitchDur } = session;

    node.textContent = arr.map((ch, i) => {
      if (ch === ' ') return ch;
      return (frame >= delays[i] && frame < delays[i] + glitchDur[i])
        ? chars[Math.floor(Math.random() * chars.length)]
        : arr[i];
    }).join('');

    session.frame++;

    // Start another ultra‑subtle round once this one ends
    if (session.frame > FRAME_COUNT + Math.max(...glitchDur)) {
      session = newSession();
      node.textContent = base; // restore baseline before new round
    }
  }, duration / FRAME_COUNT);
}

function glitchElements() {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const el = entry.target;

      const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      let node;
      while ((node = walker.nextNode())) {
        subtleScrambleTextNode(node);
        // Restart a session from time to time (very subtle)
        node._glLoop = setInterval(() => subtleScrambleTextNode(node), LOOP_INTERVAL_MS + Math.random()*4000);
      }
      observer.unobserve(el);
    });
  }, { threshold: 0.5 });

  document.querySelectorAll('p, .tagline, .subtitle').forEach(el => observer.observe(el));
}

/* ---------------------------------------------------------------------------
   RUN BOTH, IN THE RIGHT ORDER
   -------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  brutalHighlightAll();  // first – modifies DOM once
  glitchElements();      // then – launches the infinite subtle glitches
});



(() => {
  let isLoading = false;

  function findGrid(root) {
    // Le thème Split (KROWN) utilise souvent .product-item
    const firstItem = root.querySelector('.product-item');
    if (!firstItem) return null;

    // On remonte jusqu'au conteneur de grille le plus pertinent
    return (
      firstItem.closest('[id*="ProductGrid"], [id*="product-grid"], [class*="product-grid"], [class*="product-list"], [data-section-type="collection"]') ||
      firstItem.closest('ul') ||
      firstItem.closest('div') ||
      null
    );
  }

  function findPagination(root) {
    return root.querySelector('.pagination') || root.querySelector('[role="navigation"].pagination') || null;
  }

  async function applySortAjax(sortValue) {
    if (isLoading) return;
    isLoading = true;

    try {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortValue);

      const res = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const html = await res.text();
      const nextDoc = new DOMParser().parseFromString(html, 'text/html');

      const curGrid = findGrid(document);
      const nextGrid = findGrid(nextDoc);

      if (curGrid && nextGrid) {
        // Si le conteneur a un ID, on remplace par ID (plus sûr)
        if (curGrid.id && nextDoc.getElementById(curGrid.id)) {
          curGrid.innerHTML = nextDoc.getElementById(curGrid.id).innerHTML;
        } else {
          curGrid.innerHTML = nextGrid.innerHTML;
        }
      }

      const curPag = findPagination(document);
      const nextPag = findPagination(nextDoc);
      if (curPag && nextPag) curPag.innerHTML = nextPag.innerHTML;

      const curCount = document.querySelector('#CollectionProductCount');
      const nextCount = nextDoc.querySelector('#CollectionProductCount');
      if (curCount && nextCount) curCount.innerHTML = nextCount.innerHTML;

      history.replaceState({}, '', url);
    } catch (e) {
      // fallback : si jamais, au moins on ne casse pas l’UX
      console.warn('Sort AJAX failed, falling back to normal navigation', e);
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortValue);
      window.location.href = url.toString();
    } finally {
      isLoading = false;
    }
  }

  // Listener
  document.addEventListener('change', (e) => {
    if (e.target && e.target.id === 'SortBy') {
      e.preventDefault();
      applySortAjax(e.target.value);
    }
  });
})();

function closeFiltersDrawer() {
  const sidebar = document.getElementById('site-filters');
  if (!sidebar) return;

  // méthode native du thème si dispo
  if (typeof sidebar.hide === 'function') {
    sidebar.hide(true);
  } else {
    // fallback safe
    sidebar.classList.remove('active');
    sidebar.style.display = 'none';
    sidebar.setAttribute('aria-hidden', 'true');
  }

  // remet le handle à "fermé"
  const handle = document.getElementById('site-filter-handle');
  if (handle) handle.setAttribute('aria-expanded', 'false');
}

// 🔥 ferme le drawer dès qu’un filtre/tri change
document.addEventListener('change', (e) => {
  const insideFilters = e.target.closest && e.target.closest('#FacetFiltersForm');
  if (!insideFilters) return;
  closeFiltersDrawer();
});
















